@if (pageList) {
  <app-cards-basic title="{{ 'PAGES.list' | translate }}">

    <mat-nav-list>
      @for (page of pageList; track page; let first = $first) {
        <a mat-list-item
           [routerLink]="[page.id]"
           class="list-border-bottom">
          <span matListItemTitle>
            {{ page.translations[currentLanguage].title }}
          </span>
          <!-- If Default Page disable delete Button -->
          @if (first) {
            <button mat-icon-button
                    disabled
                    aria-label="Delete"
                    class="trailing-end-button">
              <mat-icon>
                <span class="material-symbols-outlined">lock</span>
              </mat-icon>
            </button>
          } @else {
            <!-- Delete Button -->
            <button mat-icon-button
                    (click)="confirmDelete(page.id, $event)"
                    aria-label="Delete"
                    class="trailing-end-button">
              <mat-icon>
                <span class="material-symbols-outlined">delete</span>
              </mat-icon>
            </button>
          }
        </a>
      }
    </mat-nav-list>

    <button mat-flat-button
            color="primary"
            type="button"
            [routerLink]="['new-page' | localize]"
            class="bp-button">
      {{ 'PAGES.create' | translate }}
    </button>


  </app-cards-basic>
}


@if (_authService.isAuthenticated()) {
}

